const config = {
    apiUrl: "https://apiodc.cloudgentechnologies.com"
}

export default config;